import React, { useContext } from 'react'
import { Topbar } from './topbar'
import { MeetingMenu } from './menu'
import { Canvas } from './canvas'
import { Sidebar } from './sidebar'
import { MeetingsContext } from '../../context/MeetingContext'
import { createPortal } from 'react-dom'
import { QuoteDialog } from './sidebar/quotes/quoteDialog'

export function Meeting() {
  const { meetingLoading, dialogState, closeDialog, quotes } = useContext(MeetingsContext)

  if (meetingLoading) {
    return (
      <div className="h-screen bg-[#EBEBEB] flex items-center justify-center">
        <div className="w-16 h-16">
          <svg className="w-16 h-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
            <radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
              <stop offset="0" stopColor="#FF156D"></stop>
              <stop offset=".3" stopColor="#FF156D" stopOpacity=".9"></stop>
              <stop offset=".6" stopColor="#FF156D" stopOpacity=".6"></stop>
              <stop offset=".8" stopColor="#FF156D" stopOpacity=".3"></stop>
              <stop offset="1" stopColor="#FF156D" stopOpacity="0"></stop>
            </radialGradient>
            <circle
              transform-origin="center"
              fill="none"
              stroke="url(#a1)"
              strokeWidth="15"
              strokeLinecap="round"
              strokeDasharray="200 1000"
              strokeDashoffset="0"
              cx="100"
              cy="100"
              r="70"
            >
              <animateTransform
                type="rotate"
                attributeName="transform"
                calcMode="spline"
                dur="2"
                values="360;0"
                keyTimes="0;1"
                keySplines="0 0 1 1"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
            <circle
              transform-origin="center"
              fill="none"
              opacity=".2"
              stroke="#FF156D"
              strokeLinecap="round"
              strokeWidth="15"
              cx="100"
              cy="100"
              r="70"
            ></circle>
          </svg>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="h-screen bg-[#EBEBEB]">
        <div className="w-full fixed top-0 bg-white z-10">
          <Topbar />
        </div>
        <div className="fixed top-[60px] bg-white" style={{ height: 'calc(100% - 40px)' }}>
          <MeetingMenu />
        </div>
        {/* width calc: 100% - 75px (marginleft) - 30px (marginRight) - 485px (sidebar) - 56px (gap with sidebar) */}
        <div
          className="fixed top-[60px] left-[75px]"
          style={{ height: 'calc(100% - 40px)', width: 'calc(100% - 75px - 30px - 485px - 56px)' }}
        >
          <Canvas />
        </div>
        <div className="fixed top-[60px] right-[30px]" style={{ height: 'calc(100% - 40px)' }}>
          <Sidebar />
        </div>
      </div>

      {dialogState.isOpen &&
        dialogState.type === 'quote' &&
        quotes.find((quote) => quote.id === dialogState.noteId) &&
        createPortal(
          <QuoteDialog
            quote={quotes.find((quote) => quote.id === dialogState.noteId)}
            closeDialog={closeDialog}
            currentQuote={quotes.findIndex((quote) => quote.id === dialogState.noteId)}
            totalQuotes={quotes.length}
          />,
          document.body
        )}
    </>
  )
}
